export const isProduction = process.env.NODE_ENV === 'production'
export const isDev = process.env.NODE_ENV === 'development'
export const isTest = process.env.NODE_ENV === 'test'

export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY
export const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID

if (!STRIPE_API_KEY || !STRIPE_CLIENT_ID) {
  console.warn(
    'Missing STRIPE api key or client id in config, check environment variables where the build was performed'
  )
}

// since we're proxying request both in development and in deploy with nginx, server url is basically
// where the app has been loaded from
export const SERVER_URL = window.location.origin

// Back app proxied in package.json in dev mode, see
// https://github.com/facebookincubator/create-react-app/blob/master/packages/react-scripts/template/README.md#proxying-api-requests-in-development
export const API_SERVER_URL = SERVER_URL

// Stripe Connect OAuth https://stripe.com/docs/connect/oauth-reference
export const STRIPE_OAUTH_REDIRECT_URI = `${SERVER_URL}/stripe-redirect`
export const STRIPE_CONNECT_LINK = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${STRIPE_OAUTH_REDIRECT_URI}`

// expose a specific base path for images in case later on we use a CDN / AWS bucket
export const MEDIA_URL = '/uploaded'

// default query page size for charities, auctions, items
export const PAGE_SIZE = 10
// used to determine within scroll if we should fetch more or not
export const MIN_OFFSET = 2
// milliseconds before automatically hiding any notification / toaster
export const NOTIFICATION_HIDE_DELAY = 5000



// WEBPACK FOOTER //
// ./src/config/index.js